module.exports = __webpack_public_path__ + "static/img/excel.327c7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/excel.png
// module id = 5jG2
// module chunks = 281